import { Button } from '@nirmata/web-components/ui/button';
import { MoonIcon, SunIcon } from '@radix-ui/react-icons';

import { useTheme } from './ThemeProvider';

export function ThemeSelector() {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      className="p-1 rounded text-[var(--primary)] hover:bg-[var(--primary)]/20 hover:text-[var(--primary)] cursor-pointer"
      onClick={toggleTheme}
      title="Toggle theme"
    >
      {theme === 'dark' ? (
        <MoonIcon className="w-5 h-5 transition-all" />
      ) : (
        <SunIcon className="w-5 h-5 transition-all" />
      )}
    </Button>
  );
}
